import { render } from "./ExpertAdd.vue?vue&type=template&id=a92db814&scoped=true"
import script from "./ExpertAdd.vue?vue&type=script&lang=js"
export * from "./ExpertAdd.vue?vue&type=script&lang=js"

import "./ExpertAdd.vue?vue&type=style&index=0&id=a92db814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92db814"]])

export default __exports__